/*
 * emailEditor: { display: { key: 'displayEmailEditor', value: displayEmailEditor }}
 * joinFilesPanel: { display: { key: 'displayJoinFilesPanel', value: displayJoinFilesPanel }}
 * processModal: { display: { key: 'displayProcessUI', value: displayProcessUI }, id: { key: 'processId', value: processId } }
 * formModal: { display: { key: 'displayFormUI', value: displayFormUI }, id: { key: 'formId', value: formId } }
 */
export type ModalDisplayRequest = {
  display: {
    key: keyof Pick<
      ModalDisplayRequester,
      | 'displayEmailEditor'
      | 'displayJoinFilesPanel'
      | 'displayExportDataModal'
      | 'displayProcessUI'
      | 'displayFormUI'
      | 'displayCustoModal'
    >;
    value: boolean;
    sourceComponent?: any;
  };
  id?: { key: keyof Pick<ModalDisplayRequester, 'formId' | 'processId'>; value: number };
};

export type ProcessModalDisplayRequest = {
  display: {
    key: keyof Pick<ProcessModalDisplayRequester, 'displayProcessUI'>;
    value: boolean;
    sourceComponent?: any;
  };
  id?: { key: keyof Pick<ProcessModalDisplayRequester, 'processId'>; value: number };
};

export type FormModalDisplayRequest = {
  display: {
    key: keyof Pick<FormModalDisplayRequester, 'displayFormUI'>;
    value: boolean;
    sourceComponent?: any;
  };
  id?: { key: keyof Pick<FormModalDisplayRequester, 'formId'>; value: number };
};

export const ModalDisplayRequest = {
  Process: (display: boolean, processId?: number, sourceComponent?: any): ModalDisplayRequest => {
    return {
      display: { key: 'displayProcessUI', value: display, sourceComponent },
      id: { key: 'processId', value: processId ?? 0 },
    };
  },
  Form: (display: boolean, formId?: number, sourceComponent?: any): ModalDisplayRequest => {
    return {
      display: { key: 'displayFormUI', value: display, sourceComponent },
      id: { key: 'formId', value: formId ?? 0 },
    };
  },
  Email: (display: boolean): ModalDisplayRequest => {
    return {
      display: { key: 'displayEmailEditor', value: display },
    };
  },
  JoinFile: (display: boolean): ModalDisplayRequest => {
    return {
      display: { key: 'displayJoinFilesPanel', value: display },
    };
  },
  ExportData: (display: boolean): ModalDisplayRequest => {
    return {
      display: { key: 'displayExportDataModal', value: display },
    };
  },
  Custo: (display: boolean): ModalDisplayRequest => {
    return {
      display: { key: 'displayCustoModal', value: display },
    };
  },
};

export type ModalDisplayRequester = ProcessModalDisplayRequester &
  FormModalDisplayRequester & {
    displayEmailEditor: boolean;
    displayJoinFilesPanel: boolean;
    displayExportDataModal: boolean;
    displayCustoModal: boolean;

    updateModalDisplay({ display, id }: ModalDisplayRequest): void;
  };

export type FormModalDisplayRequester = {
  displayFormUI: boolean;
  formId: number;

  updateModalDisplay({ display, id }: ModalDisplayRequest): void;
};

export type ProcessModalDisplayRequester = {
  displayProcessUI: boolean;
  processId: number;

  updateModalDisplay({ display, id }: ModalDisplayRequest): void;
};

export function isProcessModalDisplayRequest(request: ModalDisplayRequest): request is ProcessModalDisplayRequest {
  return request.display.key === 'displayProcessUI' && request.id?.key === 'processId';
}

export function isFormModalDisplayRequest(request: ModalDisplayRequest): request is FormModalDisplayRequest {
  return request.display.key === 'displayFormUI' && request.id?.key === 'formId';
}
